import Bathroom_F from './mapicons/Bathroom_F.png';
import Bathroom_M from './mapicons/Bathroom_M.png';

export const JJCIconArr: { name: string; image: string }[] = [
  // Female bathroom variants
  { name: 'Bathroom_F_L1', image: Bathroom_F },
  { name: 'Bathroom_F_R1', image: Bathroom_F },
  { name: 'Bathroom_F', image: Bathroom_F },
  { name: 'Bathroom_F_B1', image: Bathroom_F },
  { name: 'Bathroom_F_B2', image: Bathroom_F },
  { name: 'Bathroom_F_H', image: Bathroom_F },
  { name: 'Bathroom_F_R2', image: Bathroom_F },
  { name: 'BATHROOM_FEMALE', image: Bathroom_F },
  
  // Male bathroom variants
  { name: 'Bathroom_M_L1', image: Bathroom_M },
  { name: 'Bathroom_M_R1', image: Bathroom_M },
  { name: 'Bathroom_M', image: Bathroom_M },
  { name: 'Bathroom_M_B1', image: Bathroom_M },
  { name: 'Bathroom_M_B2', image: Bathroom_M },
  { name: 'Bathroom_M_H', image: Bathroom_M },
  { name: 'Bathroom_M_R2', image: Bathroom_M },
  { name: 'BATHROOM_MALE', image: Bathroom_M },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loadJJCImage = (mapbox: any, imageName: any, key: any) => {
  const img = new Image();
  img.src = imageName;

  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (ctx) {
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      mapbox.addImage(key, imageData);
    }
  };

  img.onerror = (error) => {
    console.error('Error loading JJC image:', error);
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addMapJJCImage = (mapbox: any) => {
  for (const icon of JJCIconArr) {
    loadJJCImage(mapbox, icon.image, icon.name);
  }
};
